/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_InterruptedInputs */



/**
* | output |
* | --- |
* | "Indexing was interrupted before it finished. Retry to run it again." |
*
* @param {Embedding_Error_InterruptedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_interrupted = /** @type {((inputs?: Embedding_Error_InterruptedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_InterruptedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Indexierung wurde vor dem Abschluss unterbrochen. Starten Sie sie erneut.")
	return /** @type {LocalizedString} */ ("Indexing was interrupted before it finished. Retry to run it again.")
});